import React, {ReactNode, ReactElement} from "react";
import ErrorBoundaryO from "@/ErrorBoundary/ErrorBoundaryO";

type AnyViewableType = ReactNode | ReactElement | string | number;
type AnyViewable = AnyViewableType | AnyViewableType[];

interface FormElementProps {
    uiParent: string;
    paramName: string;
    uiLabel: ReactNode;
    value: AnyViewable;
    required?: boolean;
}

export const FormElement: React.FC<FormElementProps> = ({
    uiParent,
    paramName,
    uiLabel,
    value,
    required = false
}) => {
    return (
        <ErrorBoundaryO uniqueKey={`form-element-${paramName}`} shouldUseErrorIcon={true}>
            <div className={`Row ${uiParent}__${paramName}`} key={paramName}>
                <div 
                    key={`FormComponent ${uiParent}__${paramName}`}
                    className={`FormComponent ${uiParent}__${paramName}`}
                >
                    <label 
                        htmlFor={paramName}
                        className={`FormComponentLabel ${required ? typeof(uiLabel) === 'string' ? 'u-required' : 'u-required-help' : ''}`}
                    >
                        {uiLabel}
                    </label>
                    <div className="FormComponentValue">
                        {value}
                    </div>
                </div>
            </div>
        </ErrorBoundaryO>
    );
};

export default FormElement;
